// Firestore singleton + typed path builders.
// Ports vanilla's ad-hoc firebase.firestore() calls (L399, L568, L611 in
// public/app/index.html) into a typed module.

import {
  getFirestore,
  doc,
  collection,
  type DocumentReference,
  type CollectionReference,
} from 'firebase/firestore'
import { firebaseApp } from './app'

export const db = getFirestore(firebaseApp)

// ── Path helpers ───────────────────────────────────────────────────────────
// Vanilla layout:
//   users/{uid}/data/{docId}   — per-user state
//   shared/{docId}             — cross-user docs (team__, uid__, user__, assign__, portallink__)

export function userDoc(uid: string, docId: string): DocumentReference {
  return doc(db, 'users', uid, 'data', docId)
}

export function userCol(uid: string): CollectionReference {
  return collection(db, 'users', uid, 'data')
}

export function sharedDoc(docId: string): DocumentReference {
  return doc(db, 'shared', docId)
}

export function sharedCol(): CollectionReference {
  return collection(db, 'shared')
}
